import * as React from "react";
import {NotFoundScreen} from "../../scenes/static/NotFoundScreen";

interface IProps {
  minWidth?: number;
  MobileComponent?: React.ComponentType;
}

interface IState {
  hasMinimum: boolean;
}

export default class LargeScreenOnlyContainer extends React.Component<
  IProps,
  IState
> {
  public static defaultProps: Partial<IProps> = {
    minWidth: 820,
    MobileComponent: NotFoundScreen
  };

  public static getDerivedStateFromProps(
    nextProps: IProps,
    prevState: IState
  ): Partial<IState> | null {
    return {
      hasMinimum: LargeScreenOnlyContainer.hasMinimumWidth(nextProps)
    };
  }

  public static hasMinimumWidth(props: IProps): boolean {
    return props.minWidth! < window.innerWidth;
  }

  public state: IState = {
    hasMinimum: true
  };

  public componentDidMount() {
    this.listenToResize();
  }

  public componentWillUnmount() {
    this.stopListeningToResize();
  }

  public render() {
    const { hasMinimum } = this.state;
    if (hasMinimum) {
      return this.props.children;
    } else {
      return this.renderBlockedPage();
    }
  }

  private listenToResize() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  private stopListeningToResize() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  private handleWindowSizeChange = () => {
    this.setState({
      hasMinimum: LargeScreenOnlyContainer.hasMinimumWidth(this.props)
    });
  };

  private renderBlockedPage() {
    const MobileComponent = this.props.MobileComponent!;
    return <MobileComponent />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Containers/LargeScreenOnlyContainer.tsx